import { defineComponent } from "vue";
import i18n from "@/i18n";
import type { IClient } from "@/models/clients";

export default defineComponent({
  methods: {
    getClientName({
      client,
      clientId,
      orEmail = false
    }: {
      client?: IClient | null;
      clientId?: IClient["id"] | null;
      orEmail?: boolean;
    }) {
      const _ = this.$_;
      clientId = _.get(client, "id", clientId);
      return _.first(
        _.compact([
          _.trim(_.get(client, "fullname", "")),
          orEmail
            ? _.trim(
                _.get(
                  client,
                  "default_email.email",
                  _.get(client, "username", "--")
                )
              )
            : null,
          _.get(client, "is_guest") ? i18n.t("_.guest_client") : "",
          _.isEmpty(client) && clientId
            ? i18n.t("_.deleted_client")
            : i18n.t("_.guest")
        ])
      );
    }
  }
});
